import { render, staticRenderFns } from "./AlgMotkaLink.vue?vue&type=template&id=419bbe4b&scoped=true&"
import script from "./AlgMotkaLink.vue?vue&type=script&lang=js&"
export * from "./AlgMotkaLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419bbe4b",
  null
  
)

export default component.exports